/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  // DatePicker,
  Table,
  // Select,
  AutoComplete,
  Input,
  //  Spin,
  Space,
  Button,
  Checkbox,
  Modal,
  Tooltip,
  Drawer,
  Typography,
  Select
  // Button,
} from "antd";
import "../index.css";
import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import api from "../../../helpers";
import toast from "react-hot-toast";
import { FaRegEdit } from "react-icons/fa";
import { loadAccessList, loadMenuList, loadUserMenuAccessList } from "../../../store/purchase-orders/actions";
import SimpleReactValidator from "simple-react-validator";

const AccessDetails = (props) => {

  const [accessTab, setAccessTab] = useState("access");

  const accessTabs = [
    { label: "Access", mode: "access" },
    { label: "Access User", mode: "accessuser" },
  ];

  const dispatch = useDispatch();

  const media = useMedia();
  const simpleValidator = useRef(new SimpleReactValidator());
  const simpleUserValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState();
  //initial state values
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  // const [pageValue, setPageValue] = useState({
  //   page: "",
  //   pageSize: "",
  // });
  const [removeBtnDisabled, setRemoveBtnDisabled] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMenuModal, setConfirmationMenuModal] = useState(false)

  const [userOpen, setUserOpen] = useState(false)
  const [menuAccess, setMenuAccess] = useState([]);
  const [accessValue, setAccessValue] = useState([]);

  console.log(menuAccess, "MenuAccess")
  console.log(accessValue, "AccessValue");


  const { menu_list } = useSelector((state) => state.PurchaseOrders);

  const [accessName, setAccessName] = useState("");
  const [description, setDescription] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [accessId, setAccessId] = useState("");
  const [menuAccessId, setMenuAccessId] = useState("")
  const [isUserEdit, setUserEdit] = useState(false);


  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadAccessList());
    dispatch(loadMenuList());
    dispatch(loadUserMenuAccessList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { access_list = {}, user_menu_list = {} } = useSelector((state) => state.PurchaseOrders);

  console.log(access_list, "access_list")
  console.log(user_menu_list, "user_menu_list");

  //header columns
  const HeaderData = [
    {
      key: "accessName",
      title: <p className="font-label text-[13px] font-semibold">Access</p>,
      dataIndex: "accessName",
      width: 100,
      // fixed: "left",
      sorter: (a, b) => a.accessName.length - b.accessName.length,
    },
    {
      key: "description",
      title: (
        <p className="font-label text-[13px] font-semibold">Description</p>
      ),
      dataIndex: "description",
      width: 130,
    },
    {
      key: "isDefault",
      title: <p className="font-label text-[13px] font-semibold">Is Default</p>,
      dataIndex: "isDefault",
      width: 80,
    },
    {
      key: "status",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "status",
      width: 80,
    },
    {
      key: "action",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "action",
      width: 70,
    },
  ];

  const AcessUser = [
    {
      key: "menuAccess",
      title: <p className="font-label text-[13px] font-semibold">
        Name</p>,
      dataIndex: "menuAccess",
      width: 100,
      // fixed: "left",

    },
    {
      key: "accessValue",
      title: (
        <p className="font-label text-[13px] font-semibold">Access</p>
      ),
      dataIndex: "accessValue",
      width: 130,
    },
    {
      key: "userStatus",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "userStatus",
      width: 80,
    },
    {
      key: "userAction",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "userAction",
      width: 70,
    },
  ]


  const accessUserTable = user_menu_list?.map(item => {
    const accesses = item.accesses?.[0] || {};
    const accessValue = Object.keys(accesses)
      .filter(key => accesses[key])
      .join(", ");

    return {
      key: item._id,
      menuAccess: item.menuName,
      accessValue: accessValue || "--",
      userAction: (
        <div className="flex">
          <Tooltip title={"Edit"} placement="top" className="mr-2">
            <div
              className={
                "cursor-pointer rounded-sm bg-[#08a35ae0] px-[8px] py-[6px] hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
              }
              onClick={() => {
                setMenuAccessId(item._id);
                setMenuAccess({ label: item.menuName, value: item.menuId });
                setAccessValue(
                  Object.keys(item.accesses[0] || {})
                    .filter(key => item.accesses[0][key])
                    .map(key => ({ label: key, value: key }))
                );
                setUserEdit(true);
                setUserOpen(true);

              }}
            >
              <FaRegEdit className="text-[14px]" />
            </div>
          </Tooltip>
          <Tooltip title={"Delete"} placement="top">
            <div
              className={
                "cursor-pointer rounded-sm bg-[#e74c3c] px-[8px] py-[6px] hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
              }
              onClick={() => {
                setMenuAccessId(item.menuId);
                setConfirmationMenuModal(true);
              }}
            >
              <DeleteOutlined className="text-[14px]" />
            </div>
          </Tooltip>
        </div>
      ),
      userStatus: (
        <div
          className={
            item &&
              item.status &&
              item.status.length > 0 &&
              item.status[0].statusCode !== undefined &&
              item.status[0].statusCode === 1
              ? "w-[60%] flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
              : "w-[60%] flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
          }
        >
          {item &&
            item.status &&
            item.status.length > 0 &&
            item.status[0].statusCode !== undefined &&
            item.status[0].statusCode === 1
            ? "Active"
            : "Inactive"}
        </div>
      ),
    };
  }) ?? [];


  const menuOptions =
    menu_list && menu_list.length > 0
      ? menu_list.flatMap((menu) => {
        // if menu has subMenus → show only subMenus with Parent → Child label
        if (menu.subMenus && menu.subMenus.length > 0) {
          return menu.subMenus.map((sub) => ({
            label: sub.menuName, // parent → child
            value: sub._id,
          }));
        }

        // if no subMenus → show parent only
        return {
          label: menu.menuName,
          value: menu._id,
        };
      })
      : [];

  console.log(menuOptions, "menuOptions");

  // const escapeCSVField = (field) => {
  //   if (typeof field === "string" && field.includes(",")) {
  //     return `"${field}"`;
  //   }
  //   return field;
  // };


  const onClose = () => {
    setOpen(false);
    setAccessName("");
    setDescription("");
    setIsDefault(false);
    setAccessId("");
  };

  const onAccessClose = () => {
    setUserOpen(false)
    setMenuAccess([])
    setAccessValue([])
    setMenuAccessId("")
  }

  const addAccessModal = () => {
    setOpen(true);
    setIsEdit(false);
    setAccessName("");
    setDescription("");
    setIsDefault(false);
    setAccessId("");
    simpleValidator.current.hideMessages();
  };

  const addUserAccessModal = () => {
    setUserOpen(true)
    setUserEdit(false)
    setMenuAccess([])
    setAccessValue([])
    setMenuAccessId("")
    simpleUserValidator.current.hideMessages()
  }

  //filters

  //  const [filteredValues, setFilteredValues] = useState("");

  const [manageOrganizationRows, setmanageOrganizationRows] = useState([
    {
      _id: "",
      accessName: "",
      descriptions: "",
      isDefault: "",
      status: "",
      action: "",
    },
  ]);




  const accessDataTable =
    !isEmpty(access_list) && access_list.length > 0
      ? access_list.map((data) => {
        return {
          _id: data._id,
          accessName: data.accessName,
          description:
            data.description !== undefined ? data.description : "--",
          isDefault: (
            <div
              className={
                data.isDefault === true
                  ? "text-[#08a35ae0] font-semibold text-start"
                  : "text-[#bb1d0d] font-semibold text-start"
              }
            >
              {data.isDefault === true ? "YES" : "NO"}
            </div>
          ),
          action: (
            <div className="flex">
              <Tooltip title={"Edit"} placement="top" className="mr-2">
                <div
                  className={
                    "cursor-pointer rounded-sm bg-[#08a35ae0] px-[8px] py-[6px] hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
                  }
                  onClick={() => {
                    setAccessId(data._id);
                    setAccessName(data.accessName);
                    setIsDefault(data.isDefault);
                    setDescription(data.description);
                    setIsEdit(true);
                    setOpen(true);
                  }}
                >
                  <FaRegEdit className="text-[14px]" />
                </div>
              </Tooltip>
              <Tooltip title={"Delete"} placement="top">
                <div
                  className={
                    "cursor-pointer rounded-sm bg-[#e74c3c] px-[8px] py-[6px] hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
                  }
                  onClick={() => {
                    setAccessId(data._id);
                    setConfirmationModal(true);
                  }}
                >
                  <DeleteOutlined className="text-[14px]" />
                </div>
              </Tooltip>
            </div>
          ),
          status: (
            <div
              className={
                data &&
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusCode !== undefined &&
                  data.status[0].statusCode === 1
                  ? "w-[60%] flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
                  : "w-[60%] flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
              }
            >
              {data &&
                data.status &&
                data.status.length > 0 &&
                data.status[0].statusCode !== undefined &&
                data.status[0].statusCode === 1
                ? "Active"
                : "Inactive"}
            </div>
          ),
        };
      })
      : [];




  const accessOptions = !isEmpty(access_list) && access_list.length > 0
    ? access_list.map((data) => {
      return {
        label: data.accessName,
        value: data._id
      }
    }) : []

  console.log(accessOptions, "accessOptions")


  useEffect(() => {
    if (accessDataTable && accessDataTable.length > 0) {
      setmanageOrganizationRows(accessDataTable);
    } else {
      setmanageOrganizationRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_list]);

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = accessDataTable.filter(
      (row) =>
        Object.values(row).some((data) =>
          String(data).toLowerCase().includes(event.target.value.toLowerCase())
        )
      // row.productName.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setSearch(event.target.value);
    setmanageOrganizationRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  // const downloadFile = ({ data, fileName, fileType }) => {
  //   const blob = new Blob([data], { type: fileType });

  //   const a = document.createElement("a");
  //   a.download = fileName;
  //   a.href = window.URL.createObjectURL(blob);
  //   const clickEvt = new MouseEvent("click", {
  //     view: window,
  //     bubbles: true,
  //     cancelable: true,
  //   });
  //   a.dispatchEvent(clickEvt);
  //   a.remove();
  // };

  // const handleDownloadPDF = () => {
  //   setDownloadLoading(true);

  //   api
  //     .post(`/org/exportallorganizations`)
  //     .then((response) => {
  //       const stockReportExcel =
  //         !isEmpty(response) && response.data.length > 0
  //           ? response.data.map((data, index) => {
  //               return {
  //                 key: index + 1,
  //                 _id: data._id,
  //                 accessName: data.accessName,

  //                 description:
  //                   data.description !== undefined ? data.description : "--",
  //                 isDefault: data.isDefault === true ? "YES" : "NO",
  //                 status:
  //                   data.status !== undefined && data.status === 1
  //                     ? "Active"
  //                     : "Inactive",
  //               };
  //             })
  //           : [];
  //       setTimeout(() => {
  //         let headerData = ["S.No, Access Name,Description,Is Default,Status"];

  //         let usersCsv = !isEmpty(stockReportExcel)
  //           ? stockReportExcel.reduce((acc, user) => {
  //               const { key, accessName, description, isDefault, status } =
  //                 user;
  //               acc.push([key, accessName, description, isDefault, status]);

  //               return acc;
  //             }, [])
  //           : false;

  //         const usersList =
  //           !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

  //         downloadFile({
  //           data: [...headerData, ...usersList].join("\n"),
  //           fileName: "ManageOrganization.csv",
  //           fileType: "text/csv",
  //         });
  //         setDownloadLoading(false);
  //       }, 2500);
  //       return response.data;
  //     })
  //     .catch((error) => Promise.reject(error));
  // };
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const createAccess = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 4000);
      const userAccountList = {
        accessName: accessName,
        isDefault: isDefault,
        description: description,
      };

      api
        .post("/masters/addaccess", userAccountList)
        .then((res) => {
          toast.success("Access created successfully");
          dispatch(loadAccessList());
          setOpen(false);
          setIsEdit(false);
          return res.data;
        })
        .catch((error) => {
          // setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while creating the access"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };
  const updateAccess = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 4000);
      const userAccountList = {
        accessName: accessName,
        isDefault: isDefault,
        description: description,
        accessId: accessId,
      };

      api
        .post("/masters/updateaccess", userAccountList)
        .then((res) => {
          toast.success("Access updated successfully");
          dispatch(loadAccessList());
          setOpen(false);
          setIsEdit(false);
          return res.data;
        })
        .catch((error) => {
          // setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while updating the access"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };







  const createUserAccess = () => {

    // REQUIRED: menu must be selected
    if (!menuAccess || !menuAccess.value) {
      toast.error("Please select a menu");
      return;
    }

    // REQUIRED: at least 1 access must be selected
    if (!accessValue || accessValue.length === 0) {
      toast.error("Please select at least one access");
      return;
    }

    if (simpleUserValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => setIsButtonDisabled(false), 4000);

      // Extract only selected access fields
      const selectedAccess = {};
      accessValue.forEach((data) => {
        selectedAccess[data.label] = true;
      });


      // Extract only subtype (after arrow)
      const menuNameOnly =
        menuAccess.label.includes("→")
          ? menuAccess.label.split("→")[1].trim()
          : menuAccess.label;

      const userAccountList = {
        menuId: menuAccess.value,
        menuName: menuNameOnly,
        accesses: [selectedAccess],  // only selected permissions
      };

      api
        .post("/masters/createmenuaccess", userAccountList)
        .then((res) => {
          toast.success("Access created successfully");
          dispatch(loadUserMenuAccessList());
          setUserOpen(false);
          setUserEdit(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            "There is an issue while creating the access";

          toast.error(errorMsg);
          return Promise.reject(error);
        });
    } else {
      simpleUserValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const updateUserAccess = () => {
    if (simpleUserValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 4000);
      const accessName1 = accessValue && accessValue.length > 0 ? accessValue.map((data) => data.label) : []

      const existedAccess = access_list && access_list.length > 0 ? access_list.map((data) => data.accessName) : []

      const accessObject = existedAccess.reduce((acc, key) => {
        acc[key] = accessName1.includes(key);
        return acc;
      }, {});
      accessObject.menuId = menuAccess.value;

      const access = [accessObject]

      const userAccountList = {
        // menuAccessId: menuAccessId,
        menuId: menuAccess.value,
        menuName: menuAccess.label,
        accesses: access

      }

      api
        .post("/masters/updatemenuaccess", userAccountList)
        .then((res) => {
          toast.success("Access updated successfully");
          dispatch(loadUserMenuAccessList());
          setUserOpen(false);
          setUserEdit(false);
          return res.data;
        })
        .catch((error) => {
          // setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while updating the access"
          );
          Promise.reject(error);
        });
    } else {
      simpleUserValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Access | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col md={20} lg={20} sm={24} xs={24} className="ml-3">
          <Row className="flex flex-row mt-2">
            {accessTabs.map((tab, index) => (
              <Col
                key={index}
                md={4}
                lg={4}
                sm={12}
                xs={24}
                className="mb-3 pr-4 cursor-pointer"
              >
                <div
                  className="p-2 text-center"
                  style={{
                    border:
                      accessTab === tab.mode
                        ? "1px solid black"
                        : "1px solid lightgray",
                    borderRadius: "20px",
                    backgroundColor: accessTab === tab.mode ? "lightgray" : "",
                  }}
                  onClick={() => setAccessTab(tab.mode)}
                >
                  <h1 style={{ fontFamily: "Poppins" }}>{tab.label}</h1>
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {accessTab === "access" && (
        <>

          <Row className="w-[100%] mt-2">
            {/* print, download section */}
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              className={
                windowDimensions.height > 700 &&
                  windowDimensions.height < 830 &&
                  accessDataTable.length > 0
                  ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                  : windowDimensions.height > 830 &&
                    windowDimensions.height < 1000 &&
                    accessDataTable.length > 0
                    ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                    : windowDimensions.height > 700 &&
                      windowDimensions.height < 830 &&
                      accessDataTable.length == 0
                      ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 1000 &&
                        accessDataTable.length == 0
                        ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
                        : windowDimensions.height >= 1000 && accessDataTable.length == 0
                          ? "mt-[1px] h-[73vh] bg-[#ffffff] rounded-md"
                          : windowDimensions.height >= 1000
                            ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
                            : "bg-[#ffffff] h-[72vh] rounded-md"
              }
            >
              <Row className="flex flex-col">
                {/* <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3">
              
            </Col> */}
                <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3 pr-5">
                  <Row className="flex justify-between">
                    <Col
                      md={10}
                      lg={10}
                      sm={24}
                      xs={24}
                      className="pr-3 lg:pr-0 md:pr-0 pl-4"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                  ? "255%"
                                  : "125%",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <div
                          className={
                            media === "sm" || media === "xs"
                              ? "w-[59%]"
                              : "w-[100%] lg:w-[65%] md:w-[65%]"
                          }
                        >
                          <AutoComplete
                            style={{
                              marginRight: "10px",
                              fontSize: "11px",
                            }}
                            // onClick={() => setSearchOpen(false)}
                            className="w-[100%]"
                          >
                            <Input.Search
                              size="middle"
                              placeholder="Search Access"
                              style={{
                                fontFamily: "Poppins",
                                // minHeight: "35px",
                                // border: "1px solid lightgray",
                                fontSize: "11px",
                              }}
                              className="rounded-sm"
                              // bordered={false}
                              name="search"
                              value={search}
                              onChange={(e) => handleSearch(e)}
                            />
                          </AutoComplete>
                        </div>
                      )}
                    </Col>
                    <Col md={14} lg={14} sm={24} xs={24} className="pr-1">
                      <Row className="flex justify-end">
                        {/* <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                ? "245%"
                                : "125%",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer flex justify-center border pt-[5px] pb-[5px] ml-4 mr-4 rounded-sm border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-sm border-1"
                                  "cursor-pointer flex justify-center border pt-[5px] pb-[5px] rounded-sm border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex justify-center">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col> */}
                        <Col
                          md={7}
                          lg={7}
                          sm={24}
                          xs={24}
                          className="mt-1 lg:mt-0 md:mt-0"
                        >
                          {loading ? (
                            <Skeleton.Input
                              style={{
                                minWidth:
                                  media === "xxl"
                                    ? "185%"
                                    : media == "sm" || media == "xs"
                                      ? "245%"
                                      : "125%",
                                paddingRight: media == "md" ? "20px" : "20px",
                                height: "35px",
                                marginLeft:
                                  media == "sm" || media == "xs" ? "10px" : "",
                              }}
                            ></Skeleton.Input>
                          ) : (
                            <Row>
                              <Col
                                md={24}
                                lg={24}
                                sm={14}
                                xs={14}
                                className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0"
                              >
                                <div
                                  onClick={() => addAccessModal()}
                                  className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]"
                                >
                                  <PlusOutlined className="mr-1" />
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="text-[14px] text-[white]"
                                  >
                                    Add Access
                                  </h1>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Drawer
                  closable={false} // hide default X icon
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                        {isEdit ? "Update Menu" : "Add Menu"}
                      </h1>
                      <Button
                        type="text"
                        onClick={onClose}
                        className="font-label"
                        icon={<CloseOutlined />}
                      />
                    </div>
                  }
                  placement="right"
                  onClose={onClose}
                  open={open}
                  width={450}
                  maskClosable={false}
                  className="font-label"
                  styles={{
                    body: {
                      padding: "18px",
                    },
                    footer: {
                      position: "sticky",
                      bottom: 0,
                      background: "#fff",
                      zIndex: 1,
                    },
                  }}
                  footer={
                    <div style={{ textAlign: "right", padding: "4px" }}>
                      <Space>
                        <Button
                          onClick={onClose}
                          style={{
                            background: "#fff1f0",
                            color: "#ff4d4f",
                            borderColor: "#ffa39e",
                          }}
                          className="font-label"
                        >
                          Cancel
                        </Button>
                        <Button
                          className="font-label"
                          type="primary"
                          disabled={isButtonDisabled ? true : false}
                          onClick={isEdit ? updateAccess : createAccess}
                        >
                          {isEdit ? "Update" : "Submit"}
                        </Button>
                      </Space>
                    </div>
                  }
                >
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      xs={24}
                      className="mb-2"
                    >
                      <Typography className="font-label text-[13px] mb-2">
                        Access Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Input
                        placeholder="Enter Access Name"
                        value={accessName}
                        className="font-label mb-2 h-[40px]"
                        // onChange={(e) => setAccessName(e.target.value)}
                        onChange={(e) => setAccessName(e.target.value.toLowerCase())}
                      />
                    </Col>

                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      xs={24}
                      className="mb-2"
                    >
                      <Typography className="font-label text-[13px] mb-2">
                        Description
                      </Typography>
                      <Input.TextArea
                        placeholder="Enter Description"
                        value={description}
                        className="font-label mb-2"
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4}
                      />
                    </Col>

                    <Col span={24}>
                      <Checkbox
                        checked={isDefault}
                        onChange={(e) => setIsDefault(e.target.checked)}
                        className="font-label"
                      >
                        Is Default
                      </Checkbox>
                    </Col>
                  </Row>
                </Drawer>

                <Col
                  span={24}
                  className={media === "xxl" ? "pt-2 pl-4 pb-4" : "pr-1 pl-4 pb-4"}
                >
                  <Table
                    style={{
                      overflow: "hidden",
                    }}
                    bordered
                    columns={HeaderData}
                    dataSource={
                      manageOrganizationRows &&
                        manageOrganizationRows.length > 0 &&
                        !isEmpty(manageOrganizationRows[0]._id)
                        ? manageOrganizationRows
                        : []
                    }
                    rowClassName={"table-row-label p-0"}
                    expandable={{
                      // expandedRowRender: expandedRowRender,
                      defaultExpandAllRows: false,
                      // expandIconColumnIndex: 5,
                    }}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      onShowSizeChange: (e) => console.log(e, "page limit"),
                      pageSizeOptions: ["5", "10", "20", "30"],
                      // onChange: (page, pageSize) =>
                      //   handlePagination(page, pageSize),
                      // page
                      // total: !isEmpty(search)
                      //   ? manageOrganizationRows.length
                      //   : access_list && access_list
                      //   ? access_list.total
                      //   : "",
                      // showTotal: (total, pageSize) => {
                      //   const indexOfLastRow =
                      //     pageSize && pageSize.length > 0 && pageSize[1];
                      //   const indexOfFirstRow =
                      //     pageSize && pageSize.length > 0 && pageSize[0];

                      //   return (
                      //     <p
                      //       style={{
                      //         fontFamily: "Poppins",
                      //         fontSize: "12px",
                      //       }}
                      //     >
                      //       Showing rows {indexOfFirstRow} to {indexOfLastRow} of{" "}
                      //       {!isEmpty(search)
                      //         ? manageOrganizationRows.length
                      //         : access_list && access_list.pagination
                      //         ? access_list.pagination.total
                      //         : total}
                      //     </p>
                      //   );
                      // },
                    }}
                    sortDirections={"ascend"}
                    loading={tableLoading ? true : false}
                    showSorterTooltip={"sorter-icon"}
                    scroll={{ x: 825 }}
                  />
                </Col>
              </Row>
            </Col>
            <Modal
              open={confirmationModal}
              onOk={() => {
                setRemoveBtnDisabled(true);
                setTimeout(() => {
                  setRemoveBtnDisabled(false);
                }, 1500);
                api
                  .post("/masters/deleteaccess", {
                    accessId: accessId,
                  })
                  .then((res) => {
                    toast.success(`${"Access deleted successfully"}`);
                    dispatch(loadAccessList());
                    return res.data;
                  })
                  .catch((error) => {
                    const errorMsg =
                      (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                      (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.error) ||
                      (error && error.message);

                    toast.error(errorMsg || "There is an issue while login");
                    Promise.reject(error);
                  });
                setConfirmationModal(false);
              }}
              closeIcon
              maskClosable={false}
              okText={"Confirm"}
              cancelText={"Cancel"}
              okType="danger"
              okButtonProps={{
                disabled: removeBtnDisabled ? true : false,
              }}
              onCancel={() => setConfirmationModal(false)}
              height={300}
              footer={(_, { OkBtn, CancelBtn }) => (
                <div className="text-center flex justify-center">
                  <CancelBtn />
                  <div className="ml-3">
                    <OkBtn />
                  </div>
                </div>
              )}
            >
              <div className="text-center w-[100%] p-7">
                <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
                <h1 className="font-label text-center text-[16px] font-bold">
                  Are you sure you want to Delete the Access?
                </h1>
              </div>
            </Modal>
          </Row>
        </>
      )}

      {accessTab === "accessuser" && (
        <>
          <Col
            md={24}
            lg={24}
            sm={24}
            xs={24}
            className={
              windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                accessDataTable.length > 0
                ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                : windowDimensions.height > 830 &&
                  windowDimensions.height < 1000 &&
                  accessDataTable.length > 0
                  ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                  : windowDimensions.height > 700 &&
                    windowDimensions.height < 830 &&
                    accessDataTable.length == 0
                    ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
                    : windowDimensions.height > 830 &&
                      windowDimensions.height < 1000 &&
                      accessDataTable.length == 0
                      ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
                      : windowDimensions.height >= 1000 && accessDataTable.length == 0
                        ? "mt-[1px] h-[73vh] bg-[#ffffff] rounded-md"
                        : windowDimensions.height >= 1000
                          ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
                          : "bg-[#ffffff] h-[72vh] rounded-md"
            }
          >
            <Row className="flex flex-col">
              {/* <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3">
              
            </Col> */}
              <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3 pr-5">
                <Row className="flex justify-between">
                  <Col
                    md={10}
                    lg={10}
                    sm={24}
                    xs={24}
                    className="pr-3 lg:pr-0 md:pr-0 pl-4"
                  >
                    {loading ? (
                      <Skeleton.Input
                        style={{
                          minWidth:
                            media === "xxl"
                              ? "185%"
                              : media == "sm" || media == "xs"
                                ? "255%"
                                : "125%",
                          height: "35px",
                        }}
                      ></Skeleton.Input>
                    ) : (
                      <div
                        className={
                          media === "sm" || media === "xs"
                            ? "w-[59%]"
                            : "w-[100%] lg:w-[65%] md:w-[65%]"
                        }
                      >
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="middle"
                            placeholder="Search Access"
                            style={{
                              fontFamily: "Poppins",
                              // minHeight: "35px",
                              // border: "1px solid lightgray",
                              fontSize: "11px",
                            }}
                            className="rounded-sm"
                            // bordered={false}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                    )}
                  </Col>
                  <Col md={14} lg={14} sm={24} xs={24} className="pr-1">
                    <Row className="flex justify-end">
                      {/* <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                ? "245%"
                                : "125%",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer flex justify-center border pt-[5px] pb-[5px] ml-4 mr-4 rounded-sm border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-sm border-1"
                                  "cursor-pointer flex justify-center border pt-[5px] pb-[5px] rounded-sm border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex justify-center">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col> */}
                      <Col
                        md={7}
                        lg={7}
                        sm={24}
                        xs={24}
                        className="mt-1 lg:mt-0 md:mt-0"
                      >
                        {loading ? (
                          <Skeleton.Input
                            style={{
                              minWidth:
                                media === "xxl"
                                  ? "185%"
                                  : media == "sm" || media == "xs"
                                    ? "245%"
                                    : "125%",
                              paddingRight: media == "md" ? "20px" : "20px",
                              height: "35px",
                              marginLeft:
                                media == "sm" || media == "xs" ? "10px" : "",
                            }}
                          ></Skeleton.Input>
                        ) : (
                          <Row>
                            <Col
                              md={24}
                              lg={24}
                              sm={14}
                              xs={14}
                              className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0"
                            >
                              <div
                                onClick={() => addUserAccessModal()}
                                className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]"
                              >
                                <PlusOutlined className="mr-1" />
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="text-[14px] text-[white]"
                                >
                                  Add Access
                                </h1>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Drawer
                closable={false} // hide default X icon
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                      {isUserEdit ? "Update User Access" : "Add User Access"}
                    </h1>
                    <Button
                      type="text"
                      onClick={onAccessClose}
                      className="font-label"
                      icon={<CloseOutlined />}
                    />
                  </div>
                }
                placement="right"
                onClose={onAccessClose}
                open={userOpen}
                width={450}
                maskClosable={false}
                className="font-label"
                styles={{
                  body: {
                    padding: "18px",
                  },
                  footer: {
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    zIndex: 1,
                  },
                }}
                footer={
                  <div style={{ textAlign: "right", padding: "4px" }}>
                    <Space>
                      <Button
                        onClick={onClose}
                        style={{
                          background: "#fff1f0",
                          color: "#ff4d4f",
                          borderColor: "#ffa39e",
                        }}
                        className="font-label"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="font-label"
                        type="primary"
                        disabled={isButtonDisabled ? true : false}
                        onClick={isUserEdit ? updateUserAccess : createUserAccess}
                      >
                        {isUserEdit ? "Update" : "Submit"}
                      </Button>
                    </Space>
                  </div>
                }
              >
                <Row>
                  <Col md={24}>
                    <Typography className="font-label mb-1 text-[13px]">
                      Menu Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={menuAccess}
                      onChange={(values) => setMenuAccess(values)}
                      labelInValue
                      placeholder="Select Menu Type"
                      // mode="multiple"
                      options={menuOptions}
                      className={
                        media === "sm"
                          ? "w-[350px] font-label h-[40px] mt-2"
                          : media === "xs"
                            ? "w-[230px] font-label h-[40px] mt-2"
                            : "w-[100%] font-label h-[40px]"
                      }
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                      }}
                    >
                      {simpleUserValidator.current.message(
                        "menuAccess",
                        menuAccess,
                        "required"
                      )}
                    </span>
                  </Col>

                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    style={{ marginBottom: 24 }}
                  >
                    <Typography className="font-label text-[13px] mt-2">
                      Access
                    </Typography>
                    <Select
                      // value={accessValue}
                      value={accessValue.length ? accessValue : undefined}
                      onChange={(values) => setAccessValue(values)}
                      labelInValue
                      placeholder="Select Access"
                      mode="multiple"
                      maxTagTextLength={11}
                      maxTagCount="responsive"
                      options={accessOptions}
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      className={
                        media === "sm"
                          ? "w-[350px] font-label h-[40px] mt-2"
                          : media === "xs"
                            ? "w-[230px] font-label h-[40px] mt-2"
                            : "w-[100%] font-label h-[40px]"
                      }
                      rootClassName="purchase-label"

                    />
                  </Col>
                </Row>
              </Drawer>

              <Col
                span={24}
                className={media === "xxl" ? "pt-2 pl-4 pb-4" : "pr-1 pl-4 pb-4"}
              >
                <Table
                  style={{
                    overflow: "hidden",
                  }}
                  bordered
                  columns={AcessUser}
                  dataSource={accessUserTable}
                  // rowClassName={"table-row-label p-0"}
                  scroll={{ x: 825 }}
                />

                <Modal
                  open={confirmationMenuModal}
                  onOk={() => {
                    setRemoveBtnDisabled(true);
                    setTimeout(() => {
                      setRemoveBtnDisabled(false);
                    }, 1500);
                    api
                      .post("/masters/deletemenuaccess", {
                        // menuId: menuId,
                        menuId: menuAccessId
                      })
                      .then((res) => {
                        toast.success(`${"Access deleted successfully"}`);
                        dispatch(loadUserMenuAccessList());
                        return res.data;
                      })
                      .catch((error) => {
                        const errorMsg =
                          (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                          (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.error) ||
                          (error && error.message);

                        toast.error(errorMsg || "There is an issue while login");
                        Promise.reject(error);
                      });
                    setConfirmationMenuModal(false);
                  }}
                  closeIcon
                  maskClosable={false}
                  okText={"Confirm"}
                  cancelText={"Cancel"}
                  okType="danger"
                  okButtonProps={{
                    disabled: removeBtnDisabled ? true : false,
                  }}
                  onCancel={() => setConfirmationMenuModal(false)}
                  height={300}
                  footer={(_, { OkBtn, CancelBtn }) => (
                    <div className="text-center flex justify-center">
                      <CancelBtn />
                      <div className="ml-3">
                        <OkBtn />
                      </div>
                    </div>
                  )}
                >
                  <div className="text-center w-[100%] p-7">
                    <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
                    <h1 className="font-label text-center text-[16px] font-bold">
                      Are you sure you want to Delete the Access?
                    </h1>
                  </div>
                </Modal>
              </Col>
            </Row>
          </Col>

        </>
      )}



    </React.Fragment>
  );
};

AccessDetails.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default AccessDetails;
